import { defineComponent } from 'vue';
import _ from 'lodash';
import dayjs from 'dayjs';
import smarty from '~/mixins/smarty';
import states from '~/assets/data/states.json';
import AddressDropdown from '~/components/members-area/AddressDropdown.vue';
import AddressSuggestionModal from '~/components/members-area/AddressSuggestionModal.vue';
import AddressErrorModal from '~/components/members-area/AddressErrorModal.vue';
import { formatBirthday, getFormErrors } from '~/utils/form';
export default defineComponent({
  name: 'ConfirmInfoSection',
  components: {
    AddressDropdown,
    AddressSuggestionModal,
    AddressErrorModal
  },
  mixins: [smarty],
  props: {
    initialForm: {
      type: Object
    }
  },
  emits: ['continue'],
  data() {
    return {
      states,
      form: _.cloneDeep(this.initialForm),
      blurredFields: {
        ssn: true
      },
      shakeForm: {},
      processing: false
    };
  },
  computed: {
    formattedBirthday() {
      return formatBirthday(this.form.date_of_birth);
    },
    isUnder18() {
      return Boolean(this.formattedBirthday && dayjs().diff(this.formattedBirthday, 'years') < 18);
    },
    formErrors() {
      const errors = getFormErrors(this.form, this.formattedBirthday);
      errors.date_of_birth = errors.date_of_birth || this.isUnder18;
      return _.omit(errors, ['email', 'phone']);
    },
    showFormError() {
      return Object.keys(this.formErrors).reduce((obj, key) => {
        obj[key] = Boolean(this.blurredFields[key] && this.formErrors[key]);
        return obj;
      }, {});
    },
    readyToSubmit() {
      return !Object.values(this.formErrors).some(Boolean);
    }
  },
  methods: {
    onFieldBlur(name) {
      this.$set(this.blurredFields, name, true);
      if (this.blurredFields[name] && this.formErrors[name]) {
        this.$set(this.shakeForm, name, true);
        setTimeout(() => {
          this.$set(this.shakeForm, name, false);
        }, 450);
      }
    },
    async submitForm() {
      if (!this.readyToSubmit) {
        return;
      }
      this.processing = true;
      const {
        success,
        formErrors,
        apiError
      } = await this.$axios.$put('/api/members/confirm-loan-info', {
        ..._.pick(this.form, ['first_name', 'last_name', 'address', 'ssn']),
        date_of_birth: this.formattedBirthday
      });
      if (success) {
        this.$emit('continue');
      } else if (formErrors) {
        this.formErrors = formErrors;
        this.shakeForm = formErrors;
        this.processing = false;
      } else if (apiError) {
        window.alert('Something went wrong. Please double check your info and try again.');
        this.processing = false;
      }
    }
  }
});